import React from 'react';
import LandingSubText from './landing-sub-text';
import Image from 'next/image';
import DynamicIcon from './dynamic-icon';

const LandingCardsGrid = ({ cards = [] }) => {
    return (
        <div className="grid lg:flex gap-[50px] lg:gap-[16px]">
            <div className='w-full lg:w-[30%] m-auto h-[420px] p-[16px] bg-white-100 grid gap-[16px] content-between rounded-[20px]'>
                <Image src='/images/flexible-structure.png' alt='fkexible structure' width={332} height={248} className='w-full'/>
                <div className='grid gap-[16px] '>
                    <p className='text-[24px] leading-[32px] text-grey-900 poppins-medium'>Flexible structure that adapts to your workflow</p>
                    <LandingSubText additionalclasses='!text-start'>Organize pages, tasks, and ideas your way—with a system that grows with you.</LandingSubText>
                </div>
            </div>
            <div className='w-full lg:w-[30%] m-auto h-[420px] py-[16px] bg-grey-900 grid content-between rounded-[20px]'>
                <div className='h-[206px] w-full rounded-[10px] px-[16px]' >
                    <p className='text-[24px] leading-[36px] text-white-50 poppins-medium'>Real-time collaboration with your team</p>
                </div>
                <div className='grid gap-[16px] mb-[18px] '>
                    <Image src='/images/landing-bars.svg' alt='collaboration' width={347} height={29} className='m-auto w-full mb-[5px]' />
                    <p className='text-[22px] leading-[32px] text-white poppins-medium px-[16px]'>Collaborate in Real-time</p>
                    <LandingSubText additionalclasses='!text-start !text-white px-[16px]'>Edit, comment, and build together instantly, no refresh needed.</LandingSubText>
                </div>
            </div>
            <div className='grid gap-[16px] lg:w-[40%] h-full'>
                <div className='w-full h-full lg:w-full m-auto p-[24px] bg-white-100 grid gap-[24px] rounded-[20px]'>
                    <p className='text-[24px] leading-[32px] text-grey-900 poppins-medium'>Create, shape, and organize with ease</p>
                    <LandingSubText additionalclasses='!text-start'>Build powerful pages using flexible blocks that fit any workflow. Rearrange, customize, and expand your content as your work evolves.</LandingSubText>
                </div>
                 <div className='w-full h-full lg:w-full m-auto p-[24px] bg-white-100 grid gap-[24px] rounded-[20px]'>
                    <DynamicIcon name='lock-keyhole' size={30} color='text-grey-900' />
                    <LandingSubText additionalclasses='!text-start'>Your data stays private and protected with built-in security.</LandingSubText>
                </div>
            </div>
        </div>
    );
};

export default LandingCardsGrid;